export const getScreenBreaks = (props: any) =>
    props.theme.mediaQueryBreakPoints;
